<template>
  <div class="supplier-tariff-display">
    <div class="supplier-logo">
      <supplier-logo :id="supplierId" small></supplier-logo>
    </div>
    <div class="display-data _margin-bottom-20">
      {{ supplierName || 'No Supplier' }}
      <h6>{{ tariffName || 'No Tariff' }}</h6>
      <uiv-btn type="link" size="xs" @click="$emit('onEdit')">Change</uiv-btn>
    </div>
  </div>
</template>

<script>
import SupplierLogo from '../../../../base/components/supplier-logo/SupplierLogo';

export default {
  name: 'SupplierTariffDisplay',
  props: {
    supplierId: {
      type: Number | String,
      default: 0
    },
    tariffName: {
      type: String,
      default: 'No Tariff'
    },
    supplierName: {
      type: String,
      default: 'No Supplier'
    },
  },
  components: {
    SupplierLogo
  }
};
</script>

<style lang="scss">
.supplier-tariff-display {
  position: relative;
  padding-left: 100px;

  .supplier-logo {
    position: absolute;
    left: 0;
    top: 13px;
  }

  h6 {
    margin: 0;
    font-size: 15px;
    line-height: 1;
    color: $metis-cloud-grey;
  }

  .btn {
    top: 20px !important;
  }
}
</style>
